import { styled, Stack } from '@mui/material';

export const StyledStatsCard = styled(Stack)(({ theme }) => ({
  width: '100%',
  flex: 1,
  padding: '3rem 5rem 4rem 5rem',
  borderRadius: '1.5rem',
  backgroundColor: '#151621',
  alignContent: 'center',
  justifyContent: 'center',
  objectRatio: '6/5',
  textAlign: 'center',
  gap: '1rem',
  [theme.breakpoints.down('md')]: {
    borderRadius: '0.75rem',
    padding: '1.5rem 1rem',
  },
}));
export const StyledImage = styled('img')(({ theme }) => ({
  width: '70%',
  height: '70%',
  objectFit: 'contain',
  objectPosition: 'center',
  alignSelf: 'center',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    height: '100%',
  },
}));
